import {useCommonComponentContext} from '@/context/ComponentContext';
import {ImageProps} from 'next/image';

export const Image = (props: ImageProps) => {
	const {Image} = useCommonComponentContext();

	if (!props.src) {
		return null;
	}

	return <Image {...props} />;
};
